import { Component } from '@angular/core';
import { UserLoyaltyComponent } from 'libs/shared/src/lib/component/user/user-loyalty/user-loyalty.component';

@Component({ standalone: false, selector: 'app-user-loyalty', templateUrl: './user-loyalty.component.html', styleUrls: ['./user-loyalty.component.scss'] })
export class CustomUserLoyaltyComponent extends UserLoyaltyComponent {}
